// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.button_mvzCr {
    text-align: left !important;
    background-color: transparent !important;
}`, "",{"version":3,"sources":["webpack://./../../packages/recovr-plugins/lib/attributes/renderers/table/LinkCell.css"],"names":[],"mappings":"AAAA;IACI,2BAA2B;IAC3B,wCAAwC;AAC5C","sourcesContent":[".button {\n    text-align: left !important;\n    background-color: transparent !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": `button_mvzCr`
};
export default ___CSS_LOADER_EXPORT___;
